var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0.25C1.92893 0.25 0.25 1.92893 0.25 4C0.25 6.07107 1.92893 7.75 4 7.75H5.875C6.91053 7.75 7.75 6.91053 7.75 5.875V4C7.75 1.92893 6.07107 0.25 4 0.25ZM1.75 3.58333C1.75 3.03105 2.19772 2.58333 2.75 2.58333H5.25C5.80228 2.58333 6.25 3.03105 6.25 3.58333C6.25 3.93116 6.07242 4.23751 5.80297 4.41667C6.07242 4.59582 6.25 4.90217 6.25 5.25C6.25 5.80228 5.80228 6.25 5.25 6.25H4C3.44772 6.25 3 5.80228 3 5.25C3 4.99388 3.09628 4.76025 3.25463 4.58333H2.75C2.19772 4.58333 1.75 4.13562 1.75 3.58333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatGrey);
export default __webpack_public_path__ + "static/media/chat-grey.7d3ea8fc.svg";
export { ForwardRef as ReactComponent };